import { Tooltip } from 'antd';
import { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLButtonElement> {
  status?: string;
  label: string;
  color?: string;
  width?: number | string;
  height?: number;
}

const ItemStatusTag: React.FC<Props> = ({
  status,
  label,
  color,
  width = 20,
  height = 20,
  ...props
}) => {
  const bgColor = status ? status.split('.').pop() : color;

  return (
    <Tooltip title={label}>
      <button
        {...props}
        style={{
          width: width,
          height: height,
          borderRadius: 4,
          backgroundColor: bgColor,
          border: 'none',
          cursor: 'pointer',
          display: 'inline-block',
          ...props.style,
        }}
      />
    </Tooltip>
  );
};

export default ItemStatusTag;
